import { localized, t } from '@weavedev/lit-i18next';
import { LitElement, html } from 'lit';
import { customElement } from 'lit/decorators.js';

import { baseStyles } from '@/styles';

@customElement('fg-configuration-error')
@localized()
export class FgConfigurationError extends LitElement {
  render() {
    return html`
      <p>${t('errors.configurationProductNotFound')}</p>
    `;
  }

  static styles = [baseStyles];
}
